export const dataPage = {
  topBar: {
    title: '律临-精选问答',
    color: '#000',
    bgColor: 'custom',
    showHomeIcon: true,
    showBackIcon: true
  },
  statBarHeight: 20,
  navBarHeight: 44,
  entireHeight: 64,
  showPage: true,
  isFenrun: false,
  nowReplies: {},
  question: {},
  // 当前菜单-默认法律法规 0 法律问答 1
  curTab: 0,
  loadData: {},
  orderType: 0,
  // 排序状态 0默认 1时间排序
  aspData: {},
  isGetData: false,
  // 939广告数据是否返回
  aspChangeData: [],
  aspChangeList: [],
  // 实验组将凤巢1059广告拆成多条
  aspFeedData: [],
  adsFilter: 0,
  // 广告是否屏蔽
  hasNewbest: false,
  // 是否有最佳答案
  user: {},
  canReply: 0,
  closeTip: 0,
  replies: [],
  relatedlist: [],
  lawAdSwitch: {},
  replyAsk: {},
  showErr: false,
  isIphoneX: false,
  hasAD: -1,
  totalTitleHeight: 58,
  loaded: false,
  // 首屏渲染的核心数据是否设置完成
  isFMPLoaded: false,
  // 与首屏渲染无关的核心数据是否设置完成
  FMPHeight: 'pre-height',
  // 控制高度，首屏内容渲染前pre-height，首屏内容渲染中fmp-height，首屏内容渲染后为空''
  errMsg: '糟糕，没有找到你访问的页面',
  shareQbListInfo: {},
  updateTime: 0,
  questionTitle: '',
  lightning: 0,
  isPageShow: false,
  isFoldAnswer: false,
  // 是否折叠了答案
  thresholdBottom: 0,
  intersectionObserverUtil: {},
  showQbCard: false,
  pathKey: '',
  isSqb: false,
  // 是否为单QB页
  isLaw: false,
  // 判断是否使用法律的样式
  wywConsultNum: 0,
  // 问一问咨询数量
  isLawRegulation: 0,
  // 判断是否是法律法规页面
  isLawsStruct: 0,
  // 判断是否是结构化法律页面
  jumpUrl: '',
  // 跳转链接
  isWhiteTop: false,
  // 滚动后顶部变成白底
  importId: 0,
  // 标识问题来源，用于区分华律和律临的问题
  adsEid: 0,
  recommendVipLawyer: [],
  dataNewbest: [],
  dataReplies: [],
  adsEids: {},
  isFolded: 0,
  // 是否默认折叠
  recommendVipLawyerInfo: {},
  lawClueConfigImageUrl: '',
  onlioneLawyerNum: 0,
  onlioneConsultants: 0
};
export const adAreaMap = {
  // h5
  0: 'ad-1929',
  1: 'ad-1930',
  // 小程序
  2: 'ad-1927',
  3: 'ad-1928'
};